import template from './premium.html';
import controller from './premium.controller';
import './premium.scss';

const premiumComponent = {
  bindings: {},
  template,
  controller,
};

export default premiumComponent;



// WEBPACK FOOTER //
// ./client/app/components/premium/premium.component.js